<template>
  <div ref="designer" style="position: absolute; left: 0; right: 0; top: 0; bottom: 0; height:800px" data-bind="dxReportDesigner: $data"></div>
</template>

<script>
  import ko from 'knockout'
  import 'devexpress-reporting/dx-reportdesigner'

  export default {
    name: 'ReportDesignerComponent',
    mounted () {
      var designerOptions = {
        reportUrl: ko.observable('NewTestReport'), // The URL of a report that is opened in the Report Designer when the application starts.
        requestOptions: {
          host: process.env.VUE_APP_REPORTS_URI,
          getDesignerModelAction: 'ReportDesigner/GetReportDesignerModel'
        }
      }
      ko.applyBindings(designerOptions, this.$refs.designer)
    },
    beforeDestroy () {
      ko.cleanNode(this.$refs.designer)
    }
  }
</script>
